import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const ChevronRight = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className={className} onClick={onClick} ref={ref}>
    <path
      fill="currentColor"
      d="M285 273 91 467c-9 10-24 10-34 0l-22-22c-10-10-10-25-1-34l155-155L34 101c-9-9-9-24 1-34l22-22c10-10 25-10 34 0l194 194c10 9 10 25 0 34z"
    />
  </svg>
));
